import { committeeMemberAddApi } from "../../api/committeeMember/committeeMemberAddApi"

type PayloadShape = Parameters<typeof committeeMemberAddApi>[0]

export async function committeeMemberAddService(payload: PayloadShape, token: string) {
	return await committeeMemberAddApi(payload, token)
}
